import React from 'react';
import UpdateAgencyBillingClosureValuesButtonProperties from "./UpdateAgencyBillingClosureValuesButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import UpdateAgencyBillingClosureValuesStore from "./UpdateAgencyBillingClosureValuesStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./UpdateAgencyBillingClosureValuesButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import useOnEnterPress from '../../../hooks/EnterPress';
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import clsx from 'clsx';
import ArticleDescriptionInput from '../../Inputs/ArticleDescriptionInput/ArticleDescriptionInput';
import PriceInput from '../../Inputs/PriceInput/PricetInput';

const UpdateAgencyBillingClosureValuesButton: React.FC<UpdateAgencyBillingClosureValuesButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  agencyBillingClosureId,
                                                                  totalAmount,
                                                                  notes,
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT,
                                                                  customButton = null,
                                                                  agencyId
                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new UpdateAgencyBillingClosureValuesStore(commonContext, agencyBillingClosureId, totalAmount, notes);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const onTotalAmountChange = (newValue: number) => {
        store.totalAmount = newValue;
    };
    const onDescriptionChange = (newNotes: string) => store.notes = newNotes;
    

    const onPromotionSave = async () => {
        const saved = await store.save();
        if (saved) {
            if (onSave) {
                onSave();
            }
            store.closeModal();
        }
    }
    useOnEnterPress(onPromotionSave, [store]);

    const text = 'Editar valores del cierre';
    const btnIcon = store.isEditing ? <Icon name={IconName.EDIT_ICON}/> : <Icon name={IconName.CREATE_ICON}/>;
    const Btn = () => {
        if (customButton != null) {
            return <div className={classes.custom_button_container} onClick={handleOnclick}>{customButton}</div>;
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal}
                       open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <PriceInput fullWidth className={classes.input}
                            value={store.totalAmount}
                            onChange={onTotalAmountChange}/>
                        <ArticleDescriptionInput className={clsx(classes.input, classes.flex_1)}
                            lines={5}
                            value={store.notes}
                            onChange={onDescriptionChange}/>
                        <div className={classes.btn_container}>
                            <Button
                                loading={store.loading} className={classes.input} onClick={onPromotionSave}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}/>
                            <Button
                                loading={store.loading} className={classes.cancel_btn} onClick={onCloseModal}
                                type={ButtonType.DEFAULT}
                                text={i18n.translate("CANCEL")}/>
                        </div>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default UpdateAgencyBillingClosureValuesButton;
